/**
 * Loads `/config.json` — same in dev (Vite middleware), preview, and production (Docker entrypoint).
 */
import {
  setRuntimeAdminUrl,
  setRuntimeApiOrigin,
  setRuntimeAssetsBaseUrl,
  setRuntimeMembersSupportEmail,
  setRuntimePricingPage,
  setRuntimePublicSiteUrl,
  setRuntimeSubscriptionMgmtLink,
} from '@/config/env.js'

function isNonEmptyString(v) {
  return typeof v === 'string' && v.trim() !== ''
}

export async function loadRuntimeConfig() {
  const res = await fetch('/config.json', { cache: 'no-store' })
  if (!res.ok) {
    throw new Error(
      `Failed to load /config.json: ${res.status} ${res.statusText}`,
    )
  }

  const data = await res.json()
  if (isNonEmptyString(data.apiOrigin)) {
    setRuntimeApiOrigin(data.apiOrigin.trim())
  }
  if (isNonEmptyString(data.publicSiteUrl)) {
    setRuntimePublicSiteUrl(data.publicSiteUrl.trim())
  }
  if (isNonEmptyString(data.assetsBaseUrl)) {
    setRuntimeAssetsBaseUrl(data.assetsBaseUrl.trim())
  }
  if (isNonEmptyString(data.adminUrl)) {
    setRuntimeAdminUrl(data.adminUrl.trim())
  }
  if (isNonEmptyString(data.pricingPage)) {
    setRuntimePricingPage(data.pricingPage.trim())
  }
  if (isNonEmptyString(data.subscriptionMgmtLink)) {
    setRuntimeSubscriptionMgmtLink(data.subscriptionMgmtLink.trim())
  }
  if (isNonEmptyString(data.membersSupportEmail)) {
    setRuntimeMembersSupportEmail(data.membersSupportEmail.trim())
  }
}
